import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewContainerRef,
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import {
  browserGpsInfo,
  getPromptFileIdsForUrls,
  isLargeScreen,
  updateCustomTableHeaders,
} from '../../../global.variable';
import { AppService } from '../../app.service';
import { ClientsService } from '../../pages/pages/clients/clients.service';

import { LoadingSpinnerService } from '../../shared/services/loading-spinner.service';
import { ToasterService } from '../../shared/services/toaster.service';
import { UsersService } from '../../pages/pages/users/users.service';
import { getDateTimeRange } from '../../pages/pages/tableDetails';
import { ModalDialogueService } from '../../shared/components/modal-dialogue/modal-dialogue.service';
import { MediaPreviewComponent } from '../../shared/components/media-preview/media-preview.component';
import { PagesService } from '../../pages/pages/pages.service';
import { ConfirmDialogComponent } from '../../shared/components/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'gtapp-checkpoint-scans',
  standalone: false,
  templateUrl: './checkpoint-scans.component.html',
  styleUrl: './checkpoint-scans.component.scss',
})
export class CheckpointScansComponent implements OnInit, OnDestroy {
  @Input() clientData: any = {};
  @Input() siteData: any = {};
  largeView: Boolean = isLargeScreen;

  browserGpsInfo: any = browserGpsInfo;

  previousScans: number = 0;
  rowsScans: number =
    this.appService.getUserData()?.preferences?.scan_page_size || 10;
  pageNumScans: number = 1;
  totalPagesScans: number = 0;
  sortKeyScans: any = '';
  searchParamsScans: any;
  totalScanCount: number = 0;

  scanPaginationData: any = {};

  hasCheckpointScans: boolean = false;

  scanDetailsTableView: any = [];

  otherParamsScans: any = {
    apiFiltering: true,
    hideHeaders: !this.largeView,
  };

  tableStyle = {
    'overflow': 'auto',
    'max-height': this.largeView ? '35vh' : '60vh',
  };

  selectedEvent: any = {};

  promptFileDataUrls: any = {};
  promptFileIds: any = [];

  constructor(
    private spinnerService: LoadingSpinnerService,
    private appService: AppService,
    private router: Router,
    private route: ActivatedRoute,
    private toasterService: ToasterService,
    private clientService: ClientsService,
    private userService: UsersService,
    private dialogService: ModalDialogueService,
    private viewContainerRef: ViewContainerRef,
    private pageService: PagesService,
  ) {}

  ngOnDestroy(): void {}
  async ngOnInit() {
    if (this.route.snapshot.queryParamMap.get('clientData')) {
      this.clientData =
        this.route.snapshot.queryParamMap.get('clientData') || {};
    }
    if (this.route.snapshot.queryParamMap.get('siteData')) {
      this.siteData = this.route.snapshot.queryParamMap.get('siteData') || {};
    }

    if (!this.clientData?.id) {
      const primeContractors: any = await this.getPrimeContractor();

      const primeContractor = primeContractors?.[0];
      if (!primeContractor) {
        this.toasterService.setMessage({
          errorMessage: '',
          successMessage: 'Prime Contractor Details Not Found',
        });
        return;
      }
      this.clientData = primeContractor;
    }
    this.formatRouteUrl();
    this.getTableDetails();
    this.getScanListData();
  }

  async getPrimeContractor() {
    const response: any = await firstValueFrom(
      this.clientService.fetchCustomerList({ prime_contractors: 1, rows: 1 }),
    );

    return response?.data || [];
  }
  async exportData(exportType: 'pdf' | 'xlsx') {
    const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: 'Email Report',
      },
    });
    const dialogResponse = await firstValueFrom(dialogRef.afterClosed());

    if (dialogResponse === true) {
      const subscriberUserId =
        this.appService.getUserData()?.subscriber?.subscriber_user_id;
      let reqBody: any = {
        export_type: exportType,
        user_ids: [subscriberUserId],
        time_offset: new Date().getTimezoneOffset(),
        event_type: 'patrol',
      };

      if (this.sortKeyScans) {
        reqBody['sort_key'] = this.sortKeyScans;
      }
      if (this.searchParamsScans) {
        reqBody.search_filters = this.searchParamsScans;
      }
      if (this.clientData?.id) reqBody.company_id = this.clientData?.id;
      this.spinnerService.show();
      this.userService.exportUserUpdateLog(reqBody).then((response: any) => {
        if (response['status'] == 'success') {
          this.toasterService.setMessage({
            successMessage: response['message'],
            errorMessage: '',
          });

          this.spinnerService.hide();
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
          this.spinnerService.hide();
        }
      });
    }
  }

  getScanListData() {
    let params: any = {};
    let reqBody: any = { event_type: 'patrol' };

    if (this.clientData?.id) reqBody.company_id = this.clientData?.id;

    if (this.previousScans) {
      reqBody['previous'] = this.previousScans;
    }
    if (this.rowsScans) reqBody.rows = this.rowsScans;

    if (this.searchParamsScans) {
      reqBody.search_filters = this.searchParamsScans;
    }

    if (this.sortKeyScans) {
      reqBody['sort_key'] = this.sortKeyScans;
    }

    if (this.scanPaginationData?.[this.pageNumScans]?.length) return;

    this.spinnerService.show();
    this.userService
      .getUserUpdateLog(reqBody, params)
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.scanPaginationData[this.pageNumScans] = [...response?.data];
          this.otherParamsScans = {
            ...this.otherParamsScans,
            paginationData: {
              totalRows: response?.total_size,
              previousRows: this.previousScans,
              rows: this.rowsScans,
              pageNum: this.pageNumScans,
              totalPages: this.totalPagesScans,
            },
          };
          this.hasCheckpointScans = response?.checkpoint_scan_exists;

          this.totalScanCount = Math.max(
            response?.total_size,
            this.totalScanCount,
            0,
          );
          this.updateRoutPath();

          this.spinnerService.hide();
        } else {
          this.spinnerService.hide();
        }
      });
  }
  onChangePaginationScan(data: any) {
    this.previousScans = data?.paginationData?.previousRows;
    this.pageNumScans = data?.paginationData?.pageNum;
    if (data?.paginationData?.rows != this.rowsScans) {
      this.scanPaginationData = {};
    }
    this.rowsScans = data?.paginationData?.rows;

    this.otherParamsScans.paginationData = {
      ...data?.paginationData,
    };

    this.getScanListData();
  }
  sortColumnScan(body: any) {
    this.sortKeyScans = body?.sortList || [];
    this.searchParamsScans = body?.searchParams || {};
    if (body?.site_id) {
      this.searchParamsScans = {
        ...this.searchParamsScans,
        site_id: body?.site_id,
      };
    }

    this.scanPaginationData = {};
    this.getScanListData();
  }
  searchColumnScan(event: any) {
    this.searchParamsScans = event?.searchParams || {};
    if (event?.site_id) {
      this.searchParamsScans = {
        ...this.searchParamsScans,
        site_id: event?.site_id,
      };
    }
    this.clearValues();
    this.getScanListData();
  }
  clearValues() {
    this.previousScans = 0;
    this.pageNumScans = 1;

    this.scanPaginationData = {};
  }

  updateRoutPath() {
    this.router.navigate([], {
      fragment: btoa(
        JSON.stringify({
          searchParams: this.searchParamsScans,
          otherParams: this.otherParamsScans,
        }),
      ),
      queryParams: {},
      replaceUrl: true,
    });
  }
  formatRouteUrl() {
    if (!this.route.snapshot.fragment) return;
    try {
      const urlFragmentDetails = JSON.parse(atob(this.route.snapshot.fragment));
      if (urlFragmentDetails && Object.keys(urlFragmentDetails)?.length) {
        this.searchParamsScans = {
          ...this.searchParamsScans,
          ...(urlFragmentDetails?.searchParams || {}),
        };

        if (urlFragmentDetails?.otherParams?.paginationData) {
          this.previousScans =
            urlFragmentDetails?.otherParams?.paginationData?.previousRows ||
            this.previousScans;
          this.pageNumScans =
            urlFragmentDetails?.otherParams?.paginationData?.pageNum ||
            this.pageNumScans;
          this.rowsScans =
            urlFragmentDetails?.otherParams?.paginationData?.rows ||
            this.rowsScans;
        }
      }
    } catch (error) {}
  }
  getNestedAssignees(rowData: any, maxNumber: any = 2) {
    if (rowData?.assignee?.length > maxNumber) {
      return `${rowData?.assignee?.slice(0, maxNumber)} ...`;
    } else {
      return rowData?.assignee;
    }
  }
  getTableDetails() {
    const eventLogDefaultDateRange = getDateTimeRange();
    this.searchParamsScans = {
      ...this.searchParamsScans,
      updated_at__range: [
        eventLogDefaultDateRange?.dateRange?.start,
        eventLogDefaultDateRange?.dateRange?.end,
      ],
    };
    let tableDetails = this.largeView
      ? [
          {
            header: 'Scanned At',
            name: 'updated_datetime',
            datetimeObj: true,
            sortKey: 'updated_datetime',
            dateRangeKey: 'updated_datetime',
            ...eventLogDefaultDateRange,
            permanent: true,
            sortOrder: 'asc',
          },

          {
            header: 'Event Type',
            name: 'action',
          },
          {
            header: 'Checkpoint',
            columnDataStyle: {
              'white-space': 'pre-line',
            },
            nestedValue: (row: any) => {
              return [0, 6, 12].includes(row?.event_action) ? row?.detail : '';
            },
          },
          {
            header: 'Location',
            nestedValue: (row: any) => {
              return `${row?.gps?.lat?.toFixed(4)}, ${row?.gps?.lon?.toFixed(4)}`;
            },
          },

          {
            header: 'Site',
            name: 'site_name',
            sortKey: 'site__company_name',
            searchKey: 'site__company_name',
            tableColumnStyle: {
              'white-space': 'pre-line',
            },
            autoComplete: 'site',
            autoCompleteFilter: { company_id: this.clientData?.id },
          },
        ]
      : [
          {
            tableColumnStyle: {
              'white-space': 'pre-line',
            },
            header: 'Scanned At',
            name: 'updated_datetime',
            datetimeObj: true,
            sortKey: 'updated_datetime',
            dateRangeKey: 'updated_datetime',
            permanent: true,
            ...eventLogDefaultDateRange,
            sortOrder: 'asc',
            suffixNestedValue: (row: any) => {
              return [0, 6, 12].includes(row?.event_action)
                ? `\n${row?.detail}`
                : null;
            },
            suffixStyle: { 'font-weight': 'bold' },
          },
          {
            header: 'Site Name',
            name: 'site_name',
            sortKey: 'site_name',
            searchKey: 'site_name',
            autoComplete: 'site',
            autoCompleteFilter: { company_id: this.clientData?.id },
            tableColumnStyle: {
              'white-space': 'pre-line',
            },
            prefixNestedValue: (row: any) => {
              const appendList: any = [row?.action, ''];

              return appendList?.join('\n');
            },

            // suffixNestedValue: (row: any) => {
            //   const appendList: any = ['', row?.full_address];
            //   return appendList?.join('\n');
            // },
          },
        ];

    updateCustomTableHeaders(tableDetails, this.searchParamsScans);

    this.scanDetailsTableView = [...tableDetails];
  }

  // }
  openScanView(scannedData: any, template: any) {
    if (![0, 6, 12].includes(scannedData?.event_action)) return;
    this.selectedEvent = scannedData;
    const newPromptFileIds = getPromptFileIdsForUrls(
      this.selectedEvent?.prompts || [],
      this.promptFileIds || [],
    );

    if (newPromptFileIds && newPromptFileIds?.length) {
      this.promptFileIds = newPromptFileIds;

      this.getS3Urls();
    }

    if (!this.largeView) {
      this.dialogService.open(template, {}, this.viewContainerRef);
    }
  }
  onOpenFile(file: any) {
    this.dialogService.open(MediaPreviewComponent, {
      data: {
        mediaSrc: file?.file || file?.file_url,
        timeStamp: file.updated_at,
        mediaExtension: file?.file_extension,
      },
    });
  }
  getS3Urls() {
    this.pageService
      .manageS3Urls({ file_ids: this.promptFileIds }, { get_file_urls: 1 })
      .subscribe((response: any) => {
        this.promptFileDataUrls = response?.data || {};
      });
  }
}
